
const system = `
You are an assistant who analyzes "items" in an array "data" and sets up a pivot grid for optimal visualization.
`

const structureData = `
The structure of a single Item in typescript is the following:
export interface Item {
	// CYCLE id numeric identifier
	cycleId: number
	// CYCLE uuid string identifier
	cycleUuid: string
	// CROP name.
	cropName: string
	// CROP LOT numeric identifier,
	cropLotId: number
	// CROP LOT string identifier
	cropLotUuid: string
	// LOT code
	lotCode: string
	// date when the CYCLE is sown. It is the start of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	seedingDate: string | null
	// date when the CYCLE is harvested. The end of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	harvestingDate: string | null
	// theoretical yield forecast in kg. It is a number
	plannedYield: number | null
	// actual yield in kg. It is a number
	yield: number | null
	// unknown
	plannedYieldBeforeIncidents: number | null
	// yield for a single TROLLEY
	yieldPerTrolley: number | null
	// number of seeds in a single TROLLEY, 
	trolleysToSeed: number | null
	// unknown
	trolleysToHarvest: number | null
	// unknown
	unitsYield: number | null
	// number of INCIDENTS for the current CYCLE
	nOfIncidents: number | null
	// number of kg lost per INCIDENTS
	lostYield: number | null
}
`

const instructions = `
Answer by generating a vanilla javascript function that has this typescript signature:
search: ( data:Item[] ) => number[]
The function accepts a "data" parameter that is an array of Item type objects.
The function returns an array of INDEXES that point to the elements of the "data" parameter.
These indicate the indices of the elements that must be selected to answer the question.
Immediately after the javascript function write a short description of the answer in the same language used for the question
`

const examples = `
EXAMPLES:
QUESTION: selects all elements of 'data' that have a yield greater than 300.
ANSWER: 'function select(data) { return data.reduce((acc, item, i) => { if (item.yeld > 300) acc.push(i); return acc }, []) }'
QUESTION: all elements harvested in the years before 2025. 
ANSWER: 'function select(data) { return data.reduce((acc, item, i) => { if (new Date(item.harvestingDate).getFullYear()<2025) acc.push(i); return acc }, []) }'
QUESTION: selects the harvest with the highest yield of all.
ANSWER: 'function select(data) { return [data.reduce((acc, item, i) => { if (item.yield > acc.max) acc = { max: item.yield, index: i }; return acc }, { max: 0, index: -1 }).index] }'
`


export const pivotGridSelectPrompt = {
	system,
	structureData,
	instructions,
	examples
}
